import Experiments from '@wix/wix-experiments';
import { EXPERIMENTS_SCOPE } from '../config/constants';
import { IChallengeExperiments } from '../editor/types/Experiments';
import memoize from 'lodash/memoize';

export async function getChallengesExperiments(options?: {
  enableNewApi?: boolean;
  ctx?: any;
  baseUrl?: string;
}): Promise<IChallengeExperiments> {
  return (await getExperimentsByScope(EXPERIMENTS_SCOPE, options)) as any;
}

export const getExperimentsByScope = memoize(
  async (
    scope: string,
    options?: { enableNewApi?: boolean; ctx?: any; baseUrl?: string },
  ) => {
    const experiments = new Experiments({
      scope,
      baseUrl: options?.baseUrl || 'https://www.wix.com',
      ...(options?.enableNewApi && { useNewApi: true }),
      requestContext: options?.ctx,
    });
    await experiments.ready();

    // Should be deleted after open OOIEnableChallengesPage
    const experimentsCSM = new Experiments({
      scope: 'client-spec-map',
      baseUrl: options?.baseUrl || 'https://www.wix.com',
    });
    await experimentsCSM.ready();

    return {
      ...experiments.all(),
      ...{
        'specs.challenges.OOIEnableChallengesPage': experimentsCSM.all()[
          'specs.challenges.OOIEnableChallengesPage'
        ],
      },
    };
  },
);

export function isEnabled(stringBool: string): boolean {
  return stringBool === 'true';
}

export function isDisabled(stringBool: string) {
  return !isEnabled(stringBool);
}
